import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Layout() {
  const { user, logout } = useAuth();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `font-display text-[0.78rem] uppercase tracking-[0.1em] px-1 py-1 ${
      isActive ? "text-maestro-900 font-semibold" : "text-maestro-700 hover:text-maestro-900"
    }`;

  return (
    <div className="min-h-screen flex flex-col bg-maestro-50">
      <header className="bg-white border-b border-maestro-200">
        <div className="max-w-5xl mx-auto px-4 py-4 flex flex-wrap items-center gap-x-6 gap-y-3">
          <NavLink to="/" className="mr-auto flex items-center gap-3">
            <img src="/logo.png" alt="Maestro" className="h-8 w-auto" />
            <span className="font-display text-[0.78rem] uppercase tracking-[0.15em] text-maestro-900/60 border-l border-maestro-200 pl-3 hidden sm:inline-block">
              Randes Search
            </span>
          </NavLink>
          <nav className="flex items-center gap-4 sm:gap-6">
            <NavLink to="/randes-search" className={linkClass}>New</NavLink>
            <NavLink to="/reports" className={linkClass}>Reports</NavLink>
          </nav>
          {user && (
            <div className="flex items-center gap-3 text-xs text-maestro-400 w-full sm:w-auto justify-between sm:justify-end border-t border-maestro-200 pt-3 sm:border-0 sm:pt-0">
              <span className="truncate max-w-[60%]">{user.email}</span>
              <button
                onClick={logout}
                className="font-display text-[0.7rem] uppercase tracking-[0.1em] text-maestro-700 hover:text-maestro-900"
                aria-label="Log out"
              >
                Log out
              </button>
            </div>
          )}
        </div>
      </header>
      <main className="flex-1 px-4 py-8 max-w-5xl w-full mx-auto">
        <Outlet />
      </main>
      <footer className="px-4 py-4 text-[0.7rem] text-maestro-400 text-center tracking-widest uppercase">
        albinsson.ai
      </footer>
    </div>
  );
}
